import { Component, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import { DragulaService } from 'ng2-dragula';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';

@Component({
  selector: 'app-lead-action',
  templateUrl: './lead-action.component.html',
  styleUrls: ['./lead-action.component.scss']
})
export class LeadActionComponent implements OnInit {

  myForm: FormGroup;
  badgeClass = 'info'
  badgeClass2 = 'success'
  badgeClass3 = 'warning'
  badgeClass4 = 'danger'
  taskData_normal: any
  taskData_medium: any
  taskData_high: any
  taskData_urgent: any

  user_role: any
  task_id: any
  normal_priority = 'normal'
  medium_priority = 'medium'
  high_priority = 'high'
  urgent_priority = 'urgent'
  
  guideline_data:any

  lead = {
    notes: '',
    next_action: '',
    last_activedate: '',
    lastresponse: '',
    next_action_date:null,
    next_action_time:null,
    priority:'',
    assign_to:[]
  }
  emp_list=[]
  selected_emp:[]=[]
  priority_list=[
    {name:'normal'},
    {name:'medium'},
    {name:'high'},
    {name:'urgent'},
  ]
  selected_priority='medium'
  nextaction_tagcat_id = '63e39b572052e0098e18dfc2'
  nextactionList = []

  current_id:any
  cover_letter:any

  priorities = [
    {
      id: 'normal',
      label: 'Normal',
      tasks: [], // Populate with taskData_normal
    },
    {
      id: 'medium',
      label: 'Medium',
      tasks: [], // Populate with taskData_medium
    },
    {
      id: 'high',
      label: 'High',
      tasks: [], // Populate with taskData_high
    },
  ];
  user_role_id:any
  constructor(private elRef: ElementRef,
    private dragulaService: DragulaService,
    private route: Router, private modalService: NgbModal,
    private apiService: ApiService, public toastr: ToastrService,
    private formBuilder: FormBuilder,private spinner: NgxSpinnerService,
  ) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Task')
    this.guideline_data = key_data[0]?._id
    
  }

  ngOnInit() {
    this.getAllEmpList()
    this.getNextActionTags()
    
    this.dragulaService.drop('ITEMS').subscribe(({ el, target }) => {
     

      const elements = el.querySelectorAll('[task-index]');
      const targett = target.querySelectorAll('[task-index]');
      var fromIndex
      var fromPriorityId
      var toIndex
      var toPriorityId

        fromIndex = el.getAttribute('task-index');
        fromPriorityId = el.getAttribute('task-priority');
        const priority_name = el.getAttribute('task-priorityname');        
      targett.forEach((element:any)=>{
        toIndex = element.getAttribute('task-index');
        toPriorityId = target.id;
      })
      this.updateTaskPriority(fromIndex,toPriorityId);
   
    });
    if(this.user_role.roles ==='admin'){
      this.getTaskByNormalPriority('')
      this.getTaskMedium('')
      this.getTaskHigh('')
      this.getTaskUrgent('')
    }
    else{
      this.getTaskByNormalPriority(this.user_role.id)
      this.getTaskMedium(this.user_role.id)
      this.getTaskHigh(this.user_role.id)
      this.getTaskUrgent(this.user_role.id)
    }
    
  }

  getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = this.padNumber(today.getMonth() + 1);
    const day = this.padNumber(today.getDate());
    return `${year}-${month}-${day}`;
  }

  padNumber(number: number): string {
    return number < 10 ? `0${number}` : `${number}`;
  }

  getTaskByNormalPriority(user) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    this.apiService.leadActionReports(1,100,'normal',user).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_normal = res?.data?.items
      this.priorities[0].tasks = this.taskData_normal;
   
    })
  }
  getTaskMedium(user) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.leadActionReports(1,100,'medium',user).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_medium = res?.data?.items
      this.priorities[1].tasks = this.taskData_medium;
    })
  }
  getTaskHigh(user) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.leadActionReports(1,100,'high',user).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_high = res?.data?.items
      this.priorities[2].tasks = this.taskData_high;

    })
  }
  getTaskUrgent(user) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.leadActionReports(1,100,'urgent',user).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_urgent = res?.data?.items
    })
  }
 
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  openUpdateModal(content,data){ 
    this.current_id = data?._id
    this.selected_emp = data.assign_to?.map(item=>item?._id)
    this.lead.assign_to = this.selected_emp
    this.selected_priority = data?.priority
    this.lead.priority = data?.priority
    this.lead.next_action = data?.leads?.next_action?._id
    this.lead.next_action_date = data?.leads?.next_action_date
    this.lead.next_action_time = data?.leads?.next_action_time
    this.lead.notes = data?.leads?.notes
    this.lead.last_activedate = data?.leads?.last_activedate
    this.lead.lastresponse = data?.leads?.lastresponse

    const modalOptions: NgbModalOptions = {
    size: 'md' 
  };
  const modalRef = this.modalService.open(content,modalOptions);
  modalRef.result.then((result) => {
    // console.log(`Modal closed with result: ${result}`);
  }, (reason) => {
    // console.log(`Modal dismissed with reason: ${reason}`);
  });
  }
  getAllEmpList(){
    this.apiService.getEmployeeList(1,100).subscribe((res:any)=>{
      this.emp_list=res?.items
    })
  }
  getEmpId(event:any){
    this.selected_emp
    this.lead.assign_to = this.selected_emp
  
  }
  getPriorityId(event:any){
    this.selected_priority
    this.lead.priority = this.selected_priority
  }
  getNextActionTags() {
    this.apiService.getTagByTagCatgoryId(this.nextaction_tagcat_id).subscribe((res: any) => {
      this.nextactionList = res.data
    })
  }
  getChangeNextAction(event) {
    this.lead.next_action
  }
  updateLead(){
    this.apiService.updateOutSourceLeads(this.current_id, this.lead).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success("Updated Successfully")
        this.modalService.dismissAll()
        if(this.user_role.roles ==='admin'){
          this.getTaskByNormalPriority('')
          this.getTaskMedium('')
          this.getTaskHigh('')
          this.getTaskUrgent('')
        }
        else{
          this.getTaskByNormalPriority(this.user_role.id)
          this.getTaskMedium(this.user_role.id)
          this.getTaskHigh(this.user_role.id)
          this.getTaskUrgent(this.user_role.id)
        }
      }
      else { this.toastr.error(res.error) }
    })
  }
  updateTask(){
    let body={
      priority: this.selected_priority,
      assign_to :this.selected_emp
    }
    
    this.apiService.createleadActionReports(this.current_id, body).subscribe((res: any) => {
      if (res.isSuccess) {
        this.toastr.success("task assign Successfully")
      }
      else { this.toastr.error(res.error) }
    })
  }
  openLetter(content, data) {
    const options: NgbModalOptions = {
      size: 'lg', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    this.cover_letter = data.coverletter
    this.modalService.open(content, options); // open the modal
  }
  
  updateTaskPriority(id: any,priority:any) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    let body={
      priority : priority
    }
    this.apiService.updateOutSourceLeads(id, body).subscribe((res: any) => {
      if(res?.isSuccess){
        this.spinner.hide()
        this.toastr.success('Priority updated successfully!')
      }
      else {
        this.spinner.hide()
        this.toastr.error(res.error)
      }
    });
  }
  
  deleteReport(id,prop){
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.removeReportLeadAction(id).subscribe((res: any) => {
      if(res?.isSuccess){
        this.spinner.hide()
        this.toastr.success('remove successfully!')
        if(this.user_role.roles ==='admin'){
          if(prop =='normal_priority'){
            this.getTaskByNormalPriority('')
          }
          
          if(prop =='medium_priority'){
            this.getTaskMedium('')
          }
          if(prop =='high_priority'){
            this.getTaskHigh('')
          }
          if(prop =='urgent_priority'){
            this.getTaskUrgent('')
          }
        }
        else{
          if(prop =='normal_priority'){
            this.getTaskByNormalPriority(this.user_role.id)
          }
          
          if(prop =='medium_priority'){
            this.getTaskMedium(this.user_role.id)
          }
          if(prop =='high_priority'){
            this.getTaskHigh(this.user_role.id)
          }
          if(prop =='urgent_priority'){
            this.getTaskUrgent(this.user_role.id)
          }
        }
        
      }
      else {
        this.spinner.hide()
        this.toastr.error(res.error)
      }
    });
  }

}
